import axios from "axios";

function generateStudentCode(lastCode) {
  if (!lastCode || typeof lastCode !== "string") return "IC701";

  lastCode = lastCode.trim();

  const numeroMatch = lastCode.match(/\d+/);
  const prefixMatch = lastCode.match(/[^\d]+/);

  const numero = numeroMatch ? parseInt(numeroMatch[0], 10) : 0;
  const prefix = prefixMatch ? prefixMatch[0] : "IC";

  const nextNumero = numero + 1;
  return prefix + String(nextNumero).padStart(3, "0");
}


export async function fetchNextStudentCode() {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/estudiantes/ultimo-codigo`
    );

    const lastCode = response?.data?.codigo;

    const nextCode = generateStudentCode(lastCode);
    return nextCode;
  } catch (error) {
    console.error("Error obteniendo el último código:", error);
    return "IC701"; // Valor por defecto en caso de error
  }
}